import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import Backend from "i18next-http-backend"
import { IS_PRODUCTION } from "./variables/config"

// import ro from "./locales/ro.json"
// import ru from "./locales/ru.json"

// i18n.use(initReactI18next).init({
//   resources: {
//     ro: { translation: ro },
//     ru: { translation: ru },
//   },
//   lng: "ro",
//   fallbackLng: "ro",
//   debug: false,
//   interpolation: {
//     escapeValue: false,
//   },
// })

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    backend: {
      loadPath: "/api/translations",
      requestOptions: {
        cache: "default",
        credentials: "include",
      },
    },
    lng: "ro",
    fallbackLng: "ro",
    supportedLngs: ["ro", "ru", "uk", "en"],
    debug: !IS_PRODUCTION,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  })

export default i18n
